module.exports = __webpack_public_path__ + "img/pr-22.2e9c323c.png";